import { render, staticRenderFns } from "./Feed_SubmenuNav.vue?vue&type=template&id=61412b71&"
import script from "./Feed_SubmenuNav.vue?vue&type=script&lang=js&"
export * from "./Feed_SubmenuNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports